import { CompanySearch } from '@/components/company-search';

/**
 * Page `/` — post-login entry point. Renders the company search screen
 * (hero + `RecentCompaniesCard`). No logic of its own; just wraps the
 * main component as a route element.
 */
export const CompanySearchPage = () => <CompanySearch />;
